import App, {$app} from './App'

const TOKEN_KEY = 'pushNotificationToken'

export default class PushNotification {
  constructor() {

    this.init()

  }

  static cleanPushToken() {
    localStorage.removeItem(TOKEN_KEY)
  }

  static hasPushToken() {
    return localStorage.getItem(TOKEN_KEY) !== null
  }

  static getPushToken() {
    return localStorage.getItem(TOKEN_KEY)
  }

  static withdrawPushToken() {
    if(PushNotification.hasPushToken()) {
      const token = PushNotification.getPushToken()

      PushNotification.cleanPushToken()

      return token
    }

    return null

  }

  saveToLocalStorage(token) {
    localStorage.setItem(TOKEN_KEY, token)
  }

  init() {
    // Define the lobsterka object if it doesn't already exist
    window.lobsterka = window.lobsterka || {}

    // Define the postMessage function on the lobsterka object
    window.lobsterka.postMessage = (functionName, data) => {
      App.$toast(`${functionName} (postMessage) called with data ${JSON.stringify(data)}`)
      console.log('Received function:', functionName)
      console.log('Received data:', data)

      // Handle different function names and data
      if(functionName === 'sendNotificationToken') {
        // Example: Handle the notification token here
        //console.log('Notification Token:', data.token)
        //console.log('Device ID:', data.deviceId)

        this.saveToLocalStorage(data.token);

        (async () => {

          const res = await $app.$api({
            action: 'set-push-token',
            method: "POST",
            data: {
              token: data.token,
              push_token: PushNotification.withdrawPushToken()
            }
          })

          App.$toast("TOKEN SEND.")
        })()


        // You can also trigger some functionality like sending data to an API, etc.
        // For example:
        // sendNotificationTokenToServer(data.token, data.deviceId);
      } else {
        console.warn('Unrecognized function:', functionName)
      }
    }
  }
}